import { render } from "./CustomerAppPage.vue?vue&type=template&id=74bc11da&ts=true"
import script from "./CustomerAppPage.vue?vue&type=script&lang=ts"
export * from "./CustomerAppPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__